import type { IKpiRepository } from '../repositories/IKpiRepository.js';
import type { KpiEntity } from '../entities/KpiEntity.js';

interface Deps { kpiRepository: IKpiRepository; }
export function createGetKpiByIdUseCase({ kpiRepository }: Deps) {
  return async function getKpiById(id: string): Promise<KpiEntity | null> {
    return kpiRepository.getById(id);
  };
}
